import { Component, OnInit } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { MatCheckboxChange } from '@angular/material/checkbox';
import { ActivatedRoute, Router } from '@angular/router';
import { AccountListEntry, BankAccountsService, CreateCredentialRequest, ProviderCredential, ProvisionAccountsRequest } from 'src/app/shared/services/bank-accounts.service';

@Component({
  selector: 'app-provider-credential-add-update',
  templateUrl: './provider-credential-add-update.component.html',
  styleUrls: ['./provider-credential-add-update.component.scss']
})
export class ProviderCredentialAddUpdateComponent implements OnInit {
  returnToCredsList: boolean = false;
  showFirstSetup: boolean = false;
  operation: string = "edit";
  savingCred: boolean = false;
  savingAccounts: boolean = false;
  stepNo: number = 1;
  accounts: AccountListEntry[] = new Array<AccountListEntry>();
  savedAccounts: AccountListEntry[] = new Array<AccountListEntry>();
  accountsDisplayCols: string[] = ['Logo', 'Name', 'AcctNum', 'Select'];
  savedAccountsDisplayCols: string[] = ['Logo', 'Name', 'AcctNum'];
  accountIdsToInclude: string[] = new Array<string>();
  credId: string = "";

  constructor(private bankAccSvc: BankAccountsService, private activatedRoute: ActivatedRoute, private router: Router, private formBuilder: FormBuilder) {

  }

  addCredentialForm = this.formBuilder.group({
    appIdCtl: ['', [Validators.required]],
    userCredCtrl: ['', Validators.required]
  });

  ngOnInit(): void {
    this.activatedRoute.queryParams
      .subscribe(params => {
        if (params['from'] != undefined) {
          var from = params['from'] as string;
          if (from === 'credsList') {
            this.returnToCredsList = true;
          }
        }

        if (params['noCreds'] != undefined) {
          var noCreds = params['noCreds'] as string;

          if (noCreds === 'true') {
            this.showFirstSetup = true;
          }
        }
      });

    var tail = this.activatedRoute.snapshot.url[this.activatedRoute.snapshot.url.length - 1];
    if (tail && tail.path === 'add') {
      this.operation = "add";
    } else {
      this.credId = this.activatedRoute.snapshot.params['credentialId'];
      this.loadExistingCred();
    }
  }

  loadExistingCred() {
    this.bankAccSvc.getProviderCredentials()
      .subscribe({
        next: (data: ProviderCredential[]) => {
          data.forEach((cred, i, arr) => {
            if (cred.Id === this.credId) {
              this.addCredentialForm.controls.appIdCtl.setValue(cred.Identifer);
            }
          });
        },
        complete: () => {

        }
      });
  }

  onCancel() {
    if (this.stepNo == 3) {
      this.stepNo = 2;
      return;
    }
    if (this.stepNo == 2) {
      this.stepNo = 1;
      return;
    }
    this.router.navigate(['/dashboard']);
  }

  onSaveCred() {
    this.savingCred = true;
    var cred = new CreateCredentialRequest();
    cred.AppSecret = this.addCredentialForm.value.appIdCtl as string;
    cred.UserSecret = this.addCredentialForm.value.userCredCtrl as string;
    this.bankAccSvc.createUpdateProviderCredential(cred)
      .subscribe({
        next: (data) => {
          this.credId = data.CredentialId;
          this.accounts = data.Accounts;
          this.stepNo = 2;
        },
        complete: () => {
          this.savingCred = false;
        }
      });
  }

  onSaveAccounts() {
    this.savingAccounts = true;

    var provReq = new ProvisionAccountsRequest();
    provReq.ProviderAccountIds = this.accountIdsToInclude;
    this.bankAccSvc.provisionProviderAccount(this.credId, provReq)
      .subscribe({
        next: (data) => {
          console.log(data);
          if (data.Success === true) {
            this.savedAccounts = new Array<AccountListEntry>();
            this.accounts.forEach((acc, i, arr) => {
              if (this.accountIdsToInclude.indexOf(acc.ProviderAccountId) > -1) {
                this.savedAccounts.push(acc);
              }
            });
            this.stepNo = 3;
          }
          console.log(this.savedAccounts);
        },
        complete: () => {
          this.savingAccounts = false;
        }
      });
  }

  onIncludeAccount(provAccId: string, event: MatCheckboxChange) {
    if (event.checked) {
      this.accountIdsToInclude.push(provAccId);
    } else {
      var indexToRemove = this.accountIdsToInclude.indexOf(provAccId, 0);
      if (indexToRemove > -1) {
        this.accountIdsToInclude.splice(indexToRemove, 1);
      }
    }
  }

  onClickFinish() {
    if (this.returnToCredsList) {
      this.router.navigate(['/bank/accounts/providers/credentials']);
    } else {
      this.router.navigate(['/dashboard']);
    }
  }

}
